import { SeasonMintType as o } from "../../constants/season.js";
import * as n from "yup";
const e = n.mixed().oneOf(Object.values(o)).default(o.NoSeason), m = n.object({
  id: n.string().default(""),
  mintType: e
}).from("mintInfo.seasonID", "id").from("mintInfo.seasonMintType", "mintType").noUnknown(!0);
export {
  m as seasonInfoSchema
};
//# sourceMappingURL=season.js.map
